import React, { useMemo, useState } from 'react';
import {
  Space,
  Row,
  Col,
  Progress,
  Divider,
  Upload,
  Card,
  Image,
  Modal,
  Button,
  Tag,
} from 'antd';
import {
  PlusOutlined,
  CheckCircleTwoTone,
  CheckCircleOutlined,
} from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { selectById } from '../../slices/tabProductsSlice';
import {
  addImage,
  createImageObj,
  FILE_UPLOAD_STATUS_ENUM,
  getFilesInFolder,
  removeImage,
} from '../../slices/productImagesSlice';
import { getBase64 } from '../../../../../../common/utils';
import _ from 'lodash';
import { CARD_TYPE_ENUM } from './AddUpdateProductFormContainer';
function ImagesTab({ productId,selectedSourceType,setSelectedSourceType }) {
  
  //selectors
  const product = useSelector((state) => selectById(state, productId));
  const s3ImageFiles = useSelector((state) =>
  getFilesInFolder(state, productId)
  );
  //dispatch
  const dispatch = useDispatch();
  //local state
  const [progress, setProgress] = useState(0);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');

  //local methods
  const convertKoganUrlToFile = () => {
    const koganImageFiles = [];
    product?.images.forEach((i, idx) => {
      const imageFile = createImageObj(`kogan_${productId}`, i);
      imageFile.sequence = idx;
      imageFile.status = FILE_UPLOAD_STATUS_ENUM.DONE.type;
      koganImageFiles.push(imageFile);
    });
    return koganImageFiles;
  };
  const getS3Files = () => {
    let imageObjs = [];
    if (s3ImageFiles) {
      imageObjs = _.values(s3ImageFiles);
    }
    return imageObjs;
  };
  //memoized functions
  const koganImages = useMemo(() => convertKoganUrlToFile(), [product?.images]);
  const s3Images = useMemo(() => getS3Files(), [s3ImageFiles]);

  //handlers
  const onCancel = () => setPreviewOpen(false);
  const onPreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf('/') + 1)
    );
  };

  const onUploadImage = (options) => {
    const { onSuccess, onError, file, onProgress } = options;
    // const config = {
    //   headers: { "content-type": "image/jpeg" },
    //   onUploadProgress: event => {
    //     const percent = Math.floor((event.loaded / event.total) * 100);
    //     setProgress(percent);
    //     if (percent === 100) {
    //       setTimeout(() => setProgress(0), 1000);
    //     }
    //     onProgress({ percent: (event.loaded / event.total) * 100 });
    //   }
    // };
      file.folder = productId;
      dispatch(addImage(file));
      onSuccess('Ok');
  };
  const onRemoveImage=(file)=>{
    dispatch(removeImage({
      ...file,
      folder:productId
    }));

  }
  //local components
  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );
  const getTitleWithBadge = (cardType) => {
    return (
      <Space size={'large'} align={'center'}>
        <span>{cardType.title}</span>
        {selectedSourceType.source === cardType.source && (
          <Tag icon={<CheckCircleOutlined />} color="green">
            Selected
          </Tag>
        )}
      </Space>
    );
  };
  const getCardStyle=(cardType)=>{
    return cardType.source === selectedSourceType.source ? {borderColor:'yellowgreen'}:{borderColor:'#f0f0f0'}
  }
  return (
    <Row gutter={[24, 24]} justify={'start'} style={{ overflow: 'auto' }}>
      <Modal open={previewOpen} footer={null} onCancel={onCancel}>
        <img
          alt={previewImage.name}
          style={{
            width: '100%',
          }}
          src={previewImage}
        />
      </Modal>
      <Col span={12}>
        <Card
          size="small"
          title={getTitleWithBadge(CARD_TYPE_ENUM.S3)}
          style={getCardStyle(CARD_TYPE_ENUM.S3)}
          actions={[
            <Button
              shape={'circle'}
              icon={<CheckCircleTwoTone />}
              onClick={() => setSelectedSourceType(CARD_TYPE_ENUM.S3)}
            />,
          ]}
        >
          <div style={{ height: '210px' }}>
            <Upload
              listType="picture-card"
              fileList={s3Images}
              accept="image/*"
              defaultFileList={s3Images}
              onPreview={onPreview}
              customRequest={onUploadImage} 
              onRemove={onRemoveImage}
              disabled={!(CARD_TYPE_ENUM.S3.source===selectedSourceType.source)}
            >
              {s3Images.length >= 10 ? null : uploadButton}
            </Upload>
          </div>
          {progress > 0 ? <Progress percent={progress} /> : null}
          <Upload multiple={true}></Upload>
        </Card>
      </Col>
      <Col span={12}>
        <Card
          size="small"
          title={getTitleWithBadge(CARD_TYPE_ENUM.KOGAN)}
          style={getCardStyle(CARD_TYPE_ENUM.KOGAN)}
          actions={[
            <Button
              shape={'circle'}
              icon={<CheckCircleTwoTone />}
              onClick={() => setSelectedSourceType(CARD_TYPE_ENUM.KOGAN)}
            />,
          ]}
        >
          <div style={{ height: '210px' }}>
            <Upload
              listType="picture-card"
              fileList={koganImages}
              accept="image/*"
              defaultFileList={koganImages}
              disabled={true}
              onPreview={onPreview}
              showUploadList={{
                showRemoveIcon: false,
              }}
            />
          </div>
        </Card>
      </Col>
    </Row>
  );
}

export default ImagesTab;
